<style lang="less" scoped>

</style>

<template>
  <v-menu
    v-if="record.id"
    :close-on-content-click="false"
    transition="scale-transition"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        style="position: relative"
        v-on="on"
      >
        <slot :item="record">
          <v-status
            class="text-underline"
            :record="record"
          />
        </slot>
      </span>
    </template>
    <v-card>
      <v-card-text style="white-space: nowrap">
        <v-row>
          <v-ripple-col>
            付款平台:
            <v-spacer />
            {{ record.payment_platform || '-' }}
          </v-ripple-col>
          <v-ripple-col>
            平台单号:
            <v-spacer />
            {{ record.ref_id }}
          </v-ripple-col>
        </v-row>
        <v-row>
          <v-ripple-col>
            对方账户:
            <v-spacer />
            {{ record.account }}
          </v-ripple-col>
          <v-ripple-col>
            对方卡号:
            <v-spacer />
            {{ record.card_no }}
          </v-ripple-col>
        </v-row>
        <v-row>
          <v-ripple-col>
            付款金额:
            <v-spacer />
            {{ $util.formatPrice(record.price) }}
          </v-ripple-col>
          <v-ripple-col>
            手续费:
            <v-spacer />
            {{ $util.formatPrice(record.fee) }}
          </v-ripple-col>
        </v-row>
        <v-row>
          <v-ripple-col>
            付款时间:
            <v-spacer />
            {{ record.paid_at ? $util.formatTime(record.paid_at) : '-' }}
          </v-ripple-col>
          <v-ripple-col>
            付款状态:
            <v-spacer />
            <v-status :record="record" />
          </v-ripple-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
  <span v-else>-</span>
</template>

<script>
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  export default {
    components: {
      'v-ripple-col': VRippleCol,
      'v-status': {
        props: {
          record: {
            type: Object
          }
        },
        render() {
          if (this.record.status === 'success') {
            return <span class="color-success">已完成</span>;
          } else if (this.record.status === 'submit') {
            return <span class="color-info">已提交</span>
          } else {
            return <span class="color-warning">{this.record.err_msg}</span>
          }
        }
      }
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      expenseGroupId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        loading: false,
        failed: false,
        record: {}
      }
    },
    computed: {
      find_url() {
        if (this.id > 0) return 'expense_payment_record/find';
        if (this.expenseGroupId > 0) return 'expense_payment_record/find_by_expense_group';
        return '';
      },
      params() {
        if (this.id > 0) return {id: this.id};
        if (this.expenseGroupId > 0) return {id: this.expenseGroupId};
        return {};
      }
    },
    watch: {
      id() {
        this.init();
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        if (!this.find_url) return;
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        this.$util.http.get(this.find_url, this.params)
          .then((data) => {
            this.record = data.record || {};
          }).catch((e) => {
            console.warn(e);
            this.failed = true;
          }).finally(() => {
            this.loading = false;
          })
      }
    }
  }
</script>
